"use client";

import * as React from "react";
import { format } from "date-fns";
import { Calendar as CalendarIcon } from "lucide-react";

import { Button } from "./button";
import { Calendar } from "./calendar";
import { Popover, PopoverContent, PopoverTrigger } from "./popover";

export function DatePicker({ defaultDate, onDateChange, classes = "" }) {
  const [open, setOpen] = React.useState(false);
  const [date, setDate] = React.useState(defaultDate || undefined);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          data-empty={!date}
          className={`data-[empty=true]:text-muted-foreground w-[280px] justify-start text-left font-normal px-2 ${classes?.button}`}
        >
          <CalendarIcon className="mr-2 h-4 w-4" />
          {date ? format(date, "dd-MM-yyyy") : <span>Pick a date</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0">
        <Calendar
          mode="single"
          selected={date}
          className="pointer-events-auto"
          onSelect={(d) => {
            setDate(d);
            onDateChange(format(d, "yyyy-MM-dd").toString());
            setOpen(false);
          }}
        />
      </PopoverContent>
    </Popover>
  );
}
